module.exports = __webpack_public_path__ + "img/double_bronze.769188db.svg";